export default "__VITE_ASSET__cbdf795a__"